import React , { useState , useEffect } from 'react'
import ReactApexChart from 'react-apexcharts';
import getChartColorsArray from '../../Components/Common/ChartsDynamicColor';
import { block } from 'marked';
import { Input, Label } from 'reactstrap';
import Flatpickr from "react-flatpickr";
import { set } from 'lodash';




const Multi_Line_chart = ({ dataColors , month_wise_token , setmonth_wise_token , graph_date_range, setgraph_date_range }) => {
    const [xaxis_per_bot, setxaxis_per_bot] = useState([]);
    const [per_bot_token_usage, setper_bot_token_usage] = useState([])
    const [xaxis_per_user, setxaxis_per_user] = useState([]);
    const [per_user_token_usage, setper_user_token_usage] = useState([])
    const [graph_value_based_on, setgraph_value_based_on] = useState('bot')
    var DashedLineColors = getChartColorsArray(dataColors);
   
    useEffect(() => {
       
        
        
        if (month_wise_token?.token_usage_per_bot?.length) {
    const rows = month_wise_token.token_usage_per_bot;

    // 1) stable, sorted ISO date keys
    const dateKeys = Array.from(new Set(rows.map(r => r.Date)))
      .sort((a, b) => new Date(a) - new Date(b));

    // 2) pretty labels for x-axis
    const dateLabels = dateKeys.map(k => {
      const d = new Date(k);
      return d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
    });
    setxaxis_per_bot(dateLabels);

    // 3) index map for fast placement
    const idxByDate = new Map(dateKeys.map((k, i) => [k, i]));

    // 4) aggregate per bot, zero-fill missing days
    const perBotMap = new Map(); // Bot_Title -> number[]
    for (const { Bot_Title, Date: d, Total_Tokens_Used } of rows) {
      if (!perBotMap.has(Bot_Title)) {
        perBotMap.set(Bot_Title, Array(dateKeys.length).fill(0));
      }
      const arr = perBotMap.get(Bot_Title);
      const idx = idxByDate.get(d);
      arr[idx] += Number(Total_Tokens_Used) || 0; // sum if duplicates
    }

    const seriesPerBot = Array.from(perBotMap.entries()).map(([name, data]) => ({ name, data }));
    setper_bot_token_usage(seriesPerBot);
  }


      if (month_wise_token?.token_usage_per_group_user?.length) {
  const rows = month_wise_token.token_usage_per_group_user;

  // 1) Build a stable, sorted date axis (keys = YYYY-MM-DD, labels = 11 Aug 2025)
  const dateKeySet = new Set(rows.map(r => r.Date)); // ISO "YYYY-MM-DD"
  const dateKeys = Array.from(dateKeySet).sort((a, b) => new Date(a) - new Date(b));

  const dateLabels = dateKeys.map(k => {
    const d = new Date(k);
    return d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
  });
  setxaxis_per_user(dateLabels);

  // 2) Build a user -> array map aligned to dateKeys
  const idxByDate = new Map(dateKeys.map((k, i) => [k, i]));
  const perUser = new Map(); // userName -> number[]

  for (const { User_Name, Date: d, Total_Tokens_Used } of rows) {
    if (!perUser.has(User_Name)) {
      perUser.set(User_Name, Array(dateKeys.length).fill(0));
    }
    const arr = perUser.get(User_Name);
    const idx = idxByDate.get(d);
    // In case there are multiple rows for the same user & date, sum them:
    arr[idx] += Number(Total_Tokens_Used) || 0;
  }

  // 3) Convert to Apex series
  const seriesPerUser = Array.from(perUser.entries()).map(([name, data]) => ({
    name,
    data,
  }));

  setper_user_token_usage(seriesPerUser);
}
        
    }, [month_wise_token]);
    

   const onChartTypeChange = (e) => {
       setgraph_value_based_on(e.target.value)
   }

const onChange_Date_range = (date_range) => {
    const formattedDates = date_range.map(date =>
        date.toLocaleDateString("en-CA") // Gives YYYY-MM-DD in local time
    );
    setgraph_date_range(formattedDates);
};

    var series = graph_value_based_on === 'bot'?per_bot_token_usage:per_user_token_usage;
    var options = {
        chart: {
            height: 500,
            type: 'line',
            zoom: {
                enabled: false
            },
            toolbar: {
    show: true,
    tools: {
      download: true,   // shows the download menu
      selection: true,
      zoom: true,
      zoomin: true,
      zoomout: true,
      pan: true,
      reset: true
    },
    export: {
      csv: {
        filename: 'token-usage',
        headerCategory: 'Date',  // x-axis header
        headerValue: 'Value',    // y header
        columnDelimiter: ',',
        dateFormatter(ts) { return ts; } // keep your formatted labels
      },
      svg: { filename: 'token-usage' },
      png: { filename: 'token-usage' }
    }
  }
        },
        // colors: DashedLineColors,
        dataLabels: {
            enabled: false
        },
        stroke: {
            width: [3, 4, 3],
            curve: 'smooth',
            dashArray: [0, 0, 0]
        },
        title: {
            text: '',            
            align: 'left',
            style: {
                fontWeight: 500,
                fill: '#000000',
                color:'#000000',
            },
        },
        markers: {
            size: 0,

            hover: {
                sizeOffset: 6
            }
        },
        xaxis: {
            categories: graph_value_based_on === 'bot'?xaxis_per_bot:xaxis_per_user,

        
        },
        tooltip: {
            y: [{
                title: {
                    formatter: function (val) {
                        return val ;
                    }
                }
            }, {
                title: {
                    formatter: function (val) {
                        return val 
                    }
                }
            }, {
                title: {
                    formatter: function (val) {
                        return val;
                    }
                }
            }]
        },
        grid: {
            borderColor: '#f1f1f1',
        }
    };
    return (
        <React.Fragment>
            <div className='drop'>
                <div className='title'>
                   <h6 class="card-title mb-0">Token Usage</h6>
                </div>
               <div className='cart_filter'>
                    <div>
                    <Label className="form-label">Sort by date</Label>
                    <Flatpickr
                       
                       onChange={onChange_Date_range}
                        className="form-control min-w"
                        options={{
                            mode: "range",
                            dateFormat: "Y-m-d"
                        }}
                        />
                    </div>
                    <div>
                    <Label htmlFor="Filter_by" className="form-label">Filter by</Label>
                    <select onChange={onChartTypeChange} className="form-select mb-3" aria-label="Default select example">                        
                        <option value="bot">Filter By Bot</option>
                        <option value="user">Filter By User</option>
                    </select>
                    </div>
               </div>
            </div>
            <ReactApexChart dir="ltr"
                options={options}
                series={series}
                type="line"
                height="380"
                className="apex-charts"
            />
        </React.Fragment>
    );
}

export default Multi_Line_chart